export default __webpack_public_path__ + "media/guidelines/dynamic-d92a0299.png";